export enum TalkPosition {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}
